const notAllowedToRevoke = (credential) => {
	return credential.state === "revoked" || credential.state === "deleted";
};

export default notAllowedToRevoke;
